import type { Option, SelectProps } from '/components/common';
import { useFormContext } from 'react-hook-form';
import { useAccounts } from '../api/getAccounts';
import { Skeleton } from '@mui/material';
import { Select } from 'components/common';
import { isEmpty } from 'lodash-es';
import { APP_LIST } from '../../../../constants';

type SelectAccountsProps = Pick<SelectProps, 'name' | 'handleChange' | 'dataTestId'>

const SelectAccounts = ({ handleChange, name, dataTestId }: SelectAccountsProps) => {
  const { watch } = useFormContext();
  const app = watch('app');

  const { data, isLoading } = useAccounts<Option[]>({
    params: { app, platform: 'WEB' },
    config: {
      enabled: !!app,
      select: (data) =>
        data.map((item) => ({
          value: item.account_id,
          label: item.name,
        })),
    },
  });
  return isLoading ? (
    <Skeleton
      width={'100%'}
      height={40}
      sx={{ transform: 'translateY(0)', borderRadius: '8px' }}
    />
  ) : (
    <Select
      name={name ?? 'account_id'}
      inputLabel={app && isEmpty(data) ? `Accounts for ${APP_LIST.find(a => a.code === app)?.name} not found` : 'Accounts'}
      disabled={isEmpty(data)}
      options={data ?? []}
      dataTestId={dataTestId}
      handleChange={handleChange}
    />
  );
};
export default SelectAccounts;